import React from 'react';

interface MaxWidthLayoutProps {
  hasMobileGutter?: boolean;
}

const MaxWidthLayout: React.FC<MaxWidthLayoutProps> = ({ children, hasMobileGutter = true }) => {
  return (
    <div
      className={`max-width-layout w-100 ${
        hasMobileGutter ? 'ph3' : 'overflow-hidden'
      } ph3-m ph4-l`}
    >
      <div className="mw9 center">{children}</div>
    </div>
  );
};

export default MaxWidthLayout;
